// =====================================================================
// lib/csv.js — une cellule de fichier CSV ouvert dans Excel (22-10-2026, revue de sécurité)
// =====================================================================
// Injection de formules : une cellule texte qui commence par = + - @ est lue comme une FORMULE par Excel
// (ex. =HYPERLINK(...) dans une description saisie par un opérateur). Précédée d'une apostrophe, elle reste du texte.
// Excel en français (séparateur de liste « ; ») coupe aussi sur « ; » et sur les retours à la ligne, même entre
// guillemets : chaque morceau après « ; », tabulation ou retour à la ligne commence une cellule et se traite pareil,
// « "=… » compris (Excel y lit "" puis =…). Seule une valeur ENTIÈRE faite d'un nombre (« -5 », « -2,5 ») reste telle
// quelle : un morceau « -5 » se colle à ce qui suit, et une heure signée « -1:30 » est une formule pour Excel (=-1:30).
// Vérifié dans Excel le 22/10. Jumeau du serveur : backend/src/services/export.util.js (neutraliserFormule).
// =====================================================================

const SEPARATEURS = /([;\t\n\r])/;
const DEBUT_FORMULE = /^"?[=+\-@]/;
const NOMBRE_SEUL = /^[-+]?\d+([.,]\d+)*$/;
const morceauSur = (m, valeurEntiere) => (DEBUT_FORMULE.test(m) && !(valeurEntiere && NOMBRE_SEUL.test(m)) ? `'${m}` : m);
export const neutraliserFormule = (s) => {
  const morceaux = s.split(SEPARATEURS);
  return morceaux.map((m, i) => (i % 2 ? m : morceauSur(m, morceaux.length === 1))).join('');
};

/** Cellule CSV entre guillemets (guillemets doublés), formule neutralisée — `String(v)` comme avant pour le reste. */
export const celluleCsv = (v) => `"${neutraliserFormule(String(v)).replace(/"/g, '""')}"`;
